'use client'

import { cn } from '../../../utils/cn'

export interface BonusBadgeProps {
  /**
   * Class name
   */
  className?: string

  /**
   * Bonus rate in percent (e.g. `25`)
   */
  rate: number
}

/**
 * 「25％おまけ」 badge shown inside the point block of a plan card.
 */
export const BonusBadge = ({ className, rate }: BonusBadgeProps) => (
  <span
    className={cn(
      // Figma: Bold 10px / 15px line height. No typography token is bold at
      // this size, so the font is set directly.
      'border border-solid border-blue-01 bg-white px-2 py-1 text-[10px] font-bold leading-[15px] tracking-[1px] text-blue-01',
      className,
    )}
  >
    {rate}％おまけ
  </span>
)
